import { combineReducers } from 'redux';
import {
    SET_SELECTED_PACKAGE_ACTION,
    CLEAR_SELECTED_PACKAGE_ACTION,
} from '../actions/routing';

const assortmentsPricing = (state = {}) => {
    const nextState = state;

    return nextState;
};

const assortmentsAvailability = (state = {}) => {
    const nextState = state;

    return nextState;
};

const feeBreakdown = (state = {}) => {
    const nextState = state;

    return nextState;
};

const hasFixedFee = (state = false) => {
    const nextState = state;

    return nextState;
};

const packageTitles = (state = '') => {
    const nextState = state;

    return nextState;
};

const selectedPackage = (state = '', action) => {
    let nextState = state;

    if (action.type === SET_SELECTED_PACKAGE_ACTION) {
        nextState = action.payload;
    } else if (action.type === CLEAR_SELECTED_PACKAGE_ACTION) {
        nextState = '';
    }

    return nextState;
};

const assortmentsTax = (state = {}) => {
    const nextState = state;

    return nextState;
};

const hasAssortmentsTax = (state = {}) => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    assortmentsPricing,
    assortmentsAvailability,
    feeBreakdown,
    hasFixedFee,
    packageTitles,
    selectedPackage,
    assortmentsTax,
    hasAssortmentsTax,
});
